import {useEvents} from "~/composables/useEvents";

export default defineNuxtPlugin(() => {
  const INTERVAL = 30000;
  const { remainEvent } = useEvents();

  setInterval(() => {
    remainEvent();
  }, INTERVAL);
});
